// Mon–Fri day headers with AM/PM under each, as grid cells. The parent grid
// puts the name column first, so these start at column 2.
import type { Day, Half } from "../lib/types";
import { dayMonth, HALF_TIMES, slotBefore, weekday } from "../lib/days";
import { Glyph } from "./Glyph";

export interface SlotHeaderProps {
  days: Day[];
  today?: Day | null;
  lockedBefore?: { day: Day; half: Half } | null;
  night?: boolean;
  /** First grid column the slots start at (1-based). */
  firstColumn?: number;
}

export function SlotHeader({ days, today, lockedBefore, night, firstColumn = 2 }: SlotHeaderProps) {
  return (
    <div className={`slots${night ? " slots--night" : ""}`} role="presentation">
      {days.map((d, i) => (
        <div key={d} className={`slot-day${d === today ? " is-today" : ""}`} style={{ gridColumn: `${firstColumn + i * 2} / span 2` }}>
          {weekday(d)} <small>{dayMonth(d)}</small>
        </div>
      ))}
      {days.flatMap((d, i) =>
        (["AM", "PM"] as Half[]).map((h, j) => {
          const locked = slotBefore(d, h, lockedBefore ?? null);
          return (
            <div key={d + h} className={`slot-half${d === today ? " is-today" : ""}${locked ? " is-locked" : ""}`}
              style={{ gridColumn: firstColumn + i * 2 + j }} title={HALF_TIMES[h].label}>
              {h}{locked && !night ? <Glyph name="lock" size={10} title="Locked" /> : null}
            </div>
          );
        })
      )}
    </div>
  );
}
